import { LOGO_URL, ECOSYSTEM } from "../data";
import { useModal } from "../context/ModalContext";

const SOCIALS = ["X", "LinkedIn", "YouTube"];

export const Footer = () => {
  const { openContact } = useModal();
  return (
    <footer
      data-testid="site-footer"
      className="bg-white text-black pt-14 pb-8 border-t"
      style={{ borderColor: "var(--border-light)" }}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="flex flex-row justify-between pb-12">
          <div>
            <img src={LOGO_URL} alt="Straight" className="h-7 w-auto mb-5" />
            <p className="text-black/50 text-lg max-w-xs">
              Global Stablecoin Card Network
            </p>
          </div>

          {/* <div className="md:col-span-3">
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-black/40 mb-5">
              Products
            </p>
            <ul className="space-y-3">
              {ECOSYSTEM.map((p) => (
                <li key={p.name}>
                  <span
                    className="text-black/70 hover:text-black transition-colors duration-300 cursor-pointer"
                    data-testid={`footer-product-${p.name.toLowerCase()}`}
                  >
                    {p.name}
                  </span>
                </li>
              ))}
            </ul>
          </div> */}

          <div>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-black/40 mb-5">
              Social
            </p>
            <ul className="space-y-3">
              {SOCIALS.map((s) => (
                <li key={s}>
                  <a
                    href="#"
                    data-testid={`footer-social-${s.toLowerCase()}`}
                    className="text-black/70 hover:text-black transition-colors duration-300"
                  >
                    {s}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div
          className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 pt-8 border-t"
          style={{ borderColor: "var(--border-light)" }}
        >
          <p className="text-black/40 text-sm">
            © 2026 Straight. All rights reserved.
          </p>
          <div className="flex items-center gap-6 text-sm text-black/50">
            <button
              onClick={openContact}
              data-testid="footer-contact"
              className="hover:text-black transition-colors duration-300"
            >
              Contact
            </button>
            <a
              href="#"
              data-testid="footer-privacy"
              className="hover:text-black transition-colors duration-300"
            >
              Privacy
            </a>
            <a
              href="#"
              data-testid="footer-terms"
              className="hover:text-black transition-colors duration-300"
            >
              Terms
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
